/**
 * Represents a position on the two-dimensional game grid.
 */
class Position {
  constructor(x, y) {
    this.x = x
    this.y = y
  }
}

export default Position


// WEBPACK FOOTER //
// ./src/domain/Position.js